import type { SVGProps } from 'react';

/**
 * The RFleet brand mark (lime rounded square + dark-green "M" polyline).
 * Single source of truth for the logo used in the sidebar, login, landing and the generated favicons
 * (see public/favicon.svg and scripts/generate-icons.mjs, which mirror these paths).
 */
export function BrandMark({ size = 42, title, ...rest }: { size?: number; title?: string } & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>) {
  return (
    <svg width={size} height={size} viewBox="0 0 42 42" fill="none" aria-hidden={title ? undefined : true} role={title ? 'img' : undefined} {...rest}>
      {title ? <title>{title}</title> : null}
      <rect width="42" height="42" rx="12" fill="#BEF264" />
      <path d="M9 30 L17 12 L23 24 L28 15 L33 30" stroke="#0F3D26" strokeWidth="4.2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="33" cy="30" r="3.2" fill="#0F3D26" />
    </svg>
  );
}
